import { apiClient } from "../client-api";
import { authHeader } from "../../_helpers";
import merge from "lodash/merge";
import appConfig from "@/app.config";

const basePath = appConfig.apiPath + "stores/";

export default {
  async query(conf = {}) {
    conf = merge({}, { headers: authHeader(), mozAnon: true }, conf);
    try {
      const response = await apiClient.get(basePath, conf);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  },
  async get(ID = 0, conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    try {
      const response = await apiClient.get(basePath + ID + "/", conf);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  },
  async insert(data = null, conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    try {
      const response = await apiClient.post(basePath, data, conf);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  },
  async delete(ID = 0, conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    try {
      const response = await apiClient.delete(basePath + ID + "/", conf);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  }
};
